import { Helmet } from 'react-helmet';
import seoMetaData from '../../../Include/Seo/seoMetaData';
import Navbar from '../../../Include/Navbar/Navbar';
import Footer from '../../../Include/Footer/Footer';
import Breadcrumb from '../MobileApp/Breadcum';
import breadcrumbData from '../Data/breadcrumbData';
import whyusData from '../Data/whyusData';
import aboutData from '../Data/aboutData';
import contactData from '../Data/contactData';
import faqData from '../Data/faqData';
import '../../../../assets/css/services.css'; // Importing the CSS file for this component
import About from '../MobileApp/About';
import Whyus from '../MobileApp/Whyus';
import Contact from '../MobileApp/Contact';
import Faq from '../MobileApp/Faq';
import Contactus from '../../Home/Contact';

export default function Index() {
  const { title, description } = seoMetaData.devOps;
  return (
    <>
     <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <link rel="canonical" href="https://www.cloudkode.com/services/devops" />
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [{
              "@type": "Question",
              "name": "What is DevOps?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "DevOps is a set of practices that combines software development (Dev) and IT operations (Ops) to shorten the systems development life cycle and provide continuous delivery with high software quality."
              }
            },{
              "@type": "Question",
              "name": "How does DevOps improve software delivery?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "DevOps improves software delivery by automating processes, enhancing collaboration between teams, and enabling faster deployment of new features and fixes."
              }
            },{
              "@type": "Question",
              "name": "What tools do you use for DevOps?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "We use a variety of tools including Jenkins, Docker, Kubernetes, and Terraform to implement DevOps practices effectively."
              }
            },{
              "@type": "Question",
              "name": "Can you help with cloud migration as part of DevOps?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes, we provide cloud migration services as part of our DevOps offerings to ensure a smooth transition to cloud environments."
              }
            }]
          }
          `}
        </script>
      </Helmet>
   <Navbar />
   <Breadcrumb data={breadcrumbData.devops} /> 
   <About data={aboutData.devops} />
   <Whyus data={whyusData.devops}/>
   <Contact data={contactData.devops}/>
   <Faq data={faqData.devops}/>
   <Contactus/>
   <Footer/>
   </>
  )
}
